import { getDataStore } from "@/api/store";

const typeNames = {
  SET_DATA_STORE: "SET_DATA_STORE",
  SET_SELECTED_INDEX: "SET_SELECTED_INDEX",
};

const state = {
  dataStore: {},
  selectedIndex: 0,
};

const mutations = {
  [typeNames.SET_DATA_STORE]: (state, dataStore) => {
    state.dataStore = dataStore;
  },
  [typeNames.SET_SELECTED_INDEX]: (state, index) => {
    state.selectedIndex = index;
  },
};

const actions = {
  getData({ commit }, storeName) {
    return new Promise((resolve, reject) => {
      getDataStore(storeName)
        .then((res) => {
          const egift_cards = res.egift_cards;
          const newCards = egift_cards
            .filter((c) => c.type == "Gift Card")
            .map((nc) => {
              const voucher = egift_cards.find(
                (ec) =>
                  ec.type == "Service Voucher" &&
                  ec.group_voucher == nc.group_voucher
              );
              if (!voucher) return nc;
              return {
                ...nc,
                voucher_amount: voucher.egift_amount,
                voucher_id: voucher.id,
              };
            });
          commit(typeNames.SET_DATA_STORE, { ...res, egift_cards: newCards });
          resolve(res);
        })
        .catch((e) => {
          commit(typeNames.SET_DATA_STORE, {
            id: 1,
            store_name: "aveaston",
            redemption_details: `
              • This eGift Card will be activated within 48 hours from the time of purchase.

              • This eGift card has to be used to top up your noon.com wallet to purchase any product on noon.com platform or please visit website https://www.noon.com/uae-en/

              • To redeem this eGift card: create your noon.com account, go to the menu, click my account, select noon credits, enter the code into the provided field, and start shopping.

              • This eGift card must be redeemed within 3 months from purchase date.
              Once this eGift card has been redeemed, the credits have no expiry date.

              • Expired eGift card cannot be extended, exchanged or refunded.

              • YouGotaGift.com does not accept cashback, refunds or returns.
            `,
            logo_url:
              "https://gamek.mediacdn.vn/zoom/700_438/2019/6/24/gogeta-super-saiyan-blue-dragon-ball-super-broly-13-4k-15613726932841860270215.jpg",
            store_display_name: "demo",
            egift_cards: [
              {
                id: 1,
                voucher_description: "demo",
                voucher_value: 12,
                store_id: 1,
                egift_amount: 12,
              },
              {
                id: 2,
                voucher_description: "demo",
                voucher_value: 12,
                store_id: 1,
                egift_amount: 12,
              },
              {
                id: 3,
                voucher_description: "demo",
                voucher_value: 12,
                store_id: 1,
                egift_amount: 12,
              },
            ],
          });
          reject(e);
        });
    });
  },
  setSelectedIndex({ commit }, index) {
    commit(typeNames.SET_SELECTED_INDEX, index);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
